import { OverlayTrigger, Tooltip } from "react-bootstrap";
import pushHistory from "../../functions/pushHistory";
import React, { useState } from "react";

interface ActionButtonProps {
	href?: string;
	history?: any;
	newWindow?: boolean;
	tooltip?: string | null;
	iconType?: string;
	icon?: string;
	show?: boolean;
	onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
	colour?: string;
	hoverColour?: string;
	pressed?: boolean;
	disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
	href = "#!",
	history = null,
	newWindow = false,
	tooltip = null,
	iconType = "material-icons",
	icon = "info",
	show = true,
	onClick = (e) => pushHistory(history, e, newWindow),
	colour = "rgb(255, 255, 255)",
	hoverColour = "rgb(240, 208, 0)",
	pressed = false,
	disabled = false,
}) => {
	const [hover, setHover] = useState(false);

	const currentColour = hover || pressed ? hoverColour : colour;
	const currentColourRaw = currentColour.replace("rgb(", "").replace(")", "");
	const styles = {
		color: `${currentColour}`,
		borderColor: `${currentColour}`,
		backgroundColor: `rgba(${currentColourRaw}, 0.1)`,
	};
	const classNames = `${iconType} notranslate action-button ${disabled ? "disabled" : ""}`;

	if (!show) return null;

	if (tooltip)
		return (
			<div>
				<OverlayTrigger
                    placement="top"
					overlay={
						<Tooltip id="actionbutton-tooltip">
							<div>{tooltip}</div>
						</Tooltip>
					}>
					<a
						href={href}
						style={styles}
						onClick={(e) => onClick(e)}
						onMouseEnter={() => setHover(true)}
						onMouseLeave={() => setHover(false)}
						className={classNames}>
						{icon}
					</a>
				</OverlayTrigger>
			</div>
		);

	return (
		<a
			href={href}
			onClick={(e) => onClick(e)}
			style={styles}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			className={classNames}>
			{icon}
		</a>
	);
};

export default ActionButton;
